import { createReducer, on } from '@ngrx/store';
import _ from 'lodash';
import { PlayMode } from './enum/media-player/media-play-mode';
import { MediaPlayerState } from './enum/media-player/media-player-state';
import { MediaType } from './enum/media-player/media-type';
import { MediaPlayerCurrentState } from './objects/media-player/media-player-current-state';
import { MediaRadio } from './objects/media-player/media-radio';
import { RadioAPI } from './objects/radio-api';
import { SearchState } from './objects/search-state';
import {
  initFetchRadiosSuccessful,
  initSearchState,
  initUserCountryCodeSuccessful,
  muteAudioVolume,
  pauseMedia,
  playMedia,
  resumeMedia,
  unmuteAudioVolume,
  updateAudioVolume,
  updateMediaContentGeneral,
  updateSearchState,
  updateSuggestedRadios,
} from './player.actions';

export const staticMediaPlayerCurrentState: MediaPlayerCurrentState =
  new MediaPlayerCurrentState(
    null,
    null,
    MediaPlayerState.NOT_INIT,
    0,
    0.15,
    0.15,
    false,
    PlayMode.NORMAL,
    '',
    '',
    '',
    2,
    120,
    44100
  );

export const mediaPlayerReducer = createReducer(
  staticMediaPlayerCurrentState,
  on(playMedia, (state, newState) => {
    var newStaticMediaPlayerCurrentState = _.cloneDeep(state);
    if (newState.mediaContent instanceof MediaRadio) {
      newStaticMediaPlayerCurrentState.mediaContent =
        newState.mediaContent as MediaRadio;
      newStaticMediaPlayerCurrentState.mediaType = MediaType.RADIO;
    } else {
      // ToDo - for tracks ...
    }
    // We expect hx-player/src/app/services/media-player/media-player.service.ts (play()) to handle state
    return newStaticMediaPlayerCurrentState;
  }),
  on(pauseMedia, (state) => {
    var newStaticMediaPlayerCurrentState = _.cloneDeep(state);
    newStaticMediaPlayerCurrentState.playerState = MediaPlayerState.PAUSE;
    return newStaticMediaPlayerCurrentState;
  }),
  on(resumeMedia, (state) => {
    var newStaticMediaPlayerCurrentState = _.cloneDeep(state);
    newStaticMediaPlayerCurrentState.playerState = MediaPlayerState.PLAYING;
    return newStaticMediaPlayerCurrentState;
  }),
  on(updateMediaContentGeneral, (state, newState) => {
    var newStaticMediaPlayerCurrentState = _.cloneDeep(state);
    if (newState.playerState != null) {
      newStaticMediaPlayerCurrentState.playerState = newState.playerState;
    }
    if (newState.progress != null) {
      newStaticMediaPlayerCurrentState.progress = newState.progress;
    }
    if (newState.currentStreamTitle != null) {
      newStaticMediaPlayerCurrentState.currentStreamTitle =
        newState.currentStreamTitle;
    }
    if (newState.currentStreamImageUrl != null) {
      newStaticMediaPlayerCurrentState.currentStreamImageUrl =
        newState.currentStreamImageUrl;
    }
    if (newState.mediaFormat != null) {
      newStaticMediaPlayerCurrentState.mediaFormat = newState.mediaFormat;
    }
    if (newState.audioChannels != null) {
      newStaticMediaPlayerCurrentState.audioChannels = newState.audioChannels;
    }
    if (newState.bitrateFromSource != null) {
      newStaticMediaPlayerCurrentState.bitrateFromSource =
        newState.bitrateFromSource;
    }
    if (newState.sampleFrequency != null) {
      newStaticMediaPlayerCurrentState.sampleFrequency =
        newState.sampleFrequency;
    }
    return newStaticMediaPlayerCurrentState;
  }),
  on(updateAudioVolume, (state, newState) => {
    var newStaticMediaPlayerCurrentState = _.cloneDeep(state);
    newStaticMediaPlayerCurrentState.volume = newState.newAudioVolume;
    newStaticMediaPlayerCurrentState.preMuteVolume = newState.newAudioVolume;
    newStaticMediaPlayerCurrentState.isMuted = false;
    return newStaticMediaPlayerCurrentState;
  }),
  on(muteAudioVolume, (state) => {
    var newStaticMediaPlayerCurrentState = _.cloneDeep(state);
    newStaticMediaPlayerCurrentState.volume = 0;
    newStaticMediaPlayerCurrentState.preMuteVolume = state.preMuteVolume;
    newStaticMediaPlayerCurrentState.isMuted = true;
    return newStaticMediaPlayerCurrentState;
  }),
  on(unmuteAudioVolume, (state) => {
    var newStaticMediaPlayerCurrentState = _.cloneDeep(state);
    newStaticMediaPlayerCurrentState.volume =
      newStaticMediaPlayerCurrentState.preMuteVolume;
    newStaticMediaPlayerCurrentState.isMuted = false;
    return newStaticMediaPlayerCurrentState;
  })
);

export const allRadios = new Array<RadioAPI>();

export const allRadiosReducer = createReducer(
  allRadios,
  on(initFetchRadiosSuccessful, (state, newState) => {
    state = newState.allRadios;
    return state;
  })
);

export const searchStateReducer = createReducer(
  new SearchState(false, ''),
  on(initSearchState, (state) => {
    return state;
  }),
  on(updateSearchState, (state, newState) => {
    let finalState = _.cloneDeep(state);
    if (newState.isEnabled !== undefined) {
      finalState.isEnabled = newState.isEnabled;
    }
    if (newState.searchText !== undefined) {
      finalState.searchText = newState.searchText;
    }
    return finalState;
  })
);

export const userCountryCodeReducer = createReducer(
  'US',
  on(initUserCountryCodeSuccessful, (state, newState) => {
    let finalState = _.cloneDeep(state);
    if (newState.countryCode !== undefined) {
      finalState = newState.countryCode;
    }
    return finalState;
  })
);

export const suggestedRadiosReducer = createReducer(
  new Array<RadioAPI>(),
  on(updateSuggestedRadios, (state, newState) => {
    return newState.suggestedRadios;
  })
);

